import { CommonModule } from '@angular/common';
import {ErrorHandler, Injector, NgModule} from '@angular/core';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { ModalModule } from 'ngx-bootstrap/modal';
import * as Sentry from '@sentry/browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {CommonUtil, TranslationService} from 'psd-common';
import { PSDTranslateLoader } from 'psd-common';
import { SharedModule } from '@app/modules/shared/shared.module';
import { GlobalErrorHandler } from 'psd-common';
import { environment } from '../environments/environment';
import { PageNotFoundComponent } from '@app/modules/error/page-not-found.component';
import { CentralLoginAppHeaderComponent } from '@app/modules/central-login/pages/central-login-app-header.component';

@NgModule({
    imports: [
        AppRoutingModule,
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        ModalModule.forRoot(),
        SharedModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateLoader,
                deps: [TranslationService]
            }
        })
    ],
    declarations: [
        AppComponent,
        CentralLoginAppHeaderComponent,
        PageNotFoundComponent
    ],
    bootstrap: [AppComponent],
    providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.recaptcha.siteKey,
            } as RecaptchaSettings,
        }
    ]
})
export class AppModule {
    constructor(private injector: Injector) {
        CommonUtil.setInjector(injector);
    }
}

export function translateLoader(translationService: TranslationService) {
    return new PSDTranslateLoader(translationService);
}
